
//
// Cart Sumamry Sync
//
// When the cart summary on this page gets updated via ajax, make sure the 'mini-cart-summary' that
// displays 'XX items in your cart' also gets appropriately updated.
//

module.exports = function CartSummarySyncController ($page, $$) {

  // Dom
  var $miniSummary = $$('.cart-mini-summary-text');

  // Widgets
  var cart = getWidgetAtDom($$('[data-widget="ajax-cart"]'));

  // Cart widget not detected? We must not have one on this page. Stop.
  if (!cart) return;

  // Update mini summary when main cart widget gets updates
  cart.onCartUpdate(function (state) {
    if (state.empty) {
      $miniSummary.text('Your cart is empty');
    } else {
      $miniSummary.text(state.count + ' ' + (state.count === 1 ? 'item' : 'items') + ' in your cart');
    }
  });

};

